import { render, staticRenderFns } from "./Menref.vue?vue&type=template&id=4f72443d&scoped=true"
import script from "./Menref.vue?vue&type=script&lang=js"
export * from "./Menref.vue?vue&type=script&lang=js"
import style0 from "./Menref.vue?vue&type=style&index=0&id=4f72443d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72443d",
  null
  
)

export default component.exports